import managecookies from './managecookies';

/*
 * Plan tiers (operator's model):
 *   basic  (₪99)  — online booking + SMS + reservations LIST by hours. NO visual LIVE/sketch.
 *   live   (₪199) — everything in basic + the visual LIVE board + floor sketch + smart seating.
 *   chain  (₪699) — everything + unlimited branches.
 *
 * The real tier lives on the business (backend column — see BACKEND_ACTS_SPEC). Until that
 * exists we read it from the session and DEFAULT TO 'chain' (full access) so nothing is
 * hidden from current users. A ?plan=basic|live|chain query or localStorage('planPreview')
 * lets the operator PREVIEW a lower tier (dev/demo only) without a backend change.
 */

export const TIERS = ['basic', 'live', 'chain'];
const RANK = { basic: 0, live: 1, chain: 2 };

const PREVIEW_KEY = 'planPreview';

// The tier-preview is an INTERNAL testing tool, gated to an explicit allowlist of the
// operator's OWN businesses — NOT to "any owner" (a real paying basic-plan owner must not be
// able to self-upgrade the UI past their subscription, since plan gating is still client-side
// only). Remove/replace with server-side plan enforcement before onboarding paying customers.
const PREVIEW_ALLOWLIST = ['y2rys2jdpfXi1Sj', 'DCXYCe2xL7s5G1M']; // Lega6, test (operator's dev businesses)
export function isPlanPreviewAllowed() {
    try {
        const data = JSON.parse(managecookies.getCookieVal('userData') || '{}');
        const biz = data.business && data.business[0];
        return !!(biz && PREVIEW_ALLOWLIST.includes(biz.businessToken));
    } catch (e) { return false; }
}

// The operator's PREVIEW override (localStorage / ?plan=), so tiers can be compared live.
// Honored ONLY for allowlisted businesses (isPlanPreviewAllowed); precedence over real plan.
export function getPlanPreview() {
    try {
        if (typeof window === 'undefined') return null;
        if (!isPlanPreviewAllowed()) return null;
        const q = new URLSearchParams(window.location.search).get('plan');
        if (q && TIERS.includes(q)) { window.localStorage.setItem(PREVIEW_KEY, q); return q; }
        const stored = window.localStorage.getItem(PREVIEW_KEY);
        if (stored && TIERS.includes(stored)) return stored;
    } catch (e) { /* ignore */ }
    return null;
}

export function setPlanPreview(plan) {
    try { if (TIERS.includes(plan)) window.localStorage.setItem(PREVIEW_KEY, plan); } catch (e) { /* ignore */ }
}

export function clearPlanPreview() {
    try { window.localStorage.removeItem(PREVIEW_KEY); } catch (e) { /* ignore */ }
}

// The real business plan from the session (ignores any preview). null if not set.
export function getRealPlan() {
    try {
        const data = JSON.parse(managecookies.getCookieVal('userData') || '{}');
        const biz = data.business && data.business[0];
        const plan = (biz && (biz.plan || biz.tier)) || data.plan;
        if (plan && TIERS.includes(plan)) return plan;
    } catch (e) { /* ignore */ }
    return null;
}

export function getPlan() {
    // 1) operator preview override (if any) — lets tiers be compared live.
    const preview = getPlanPreview();
    if (preview) return preview;
    // 2) real business plan from the session.
    const real = getRealPlan();
    if (real) return real;
    // 3) default: full access, so no feature is hidden before the backend sets a real plan.
    return 'chain';
}

// Feature checks.
export const hasLive = (plan = getPlan()) => RANK[plan] >= RANK.live;     // visual board + sketch
export const hasBranches = (plan = getPlan()) => RANK[plan] >= RANK.chain; // multi-branch

export const PLAN_LABEL = { basic: 'בסיסי', live: 'מקצועי (LIVE)', chain: 'רשתות' };
